<template>
  <div class="xdeerrtts">
    <img src="../assets/img/bhjhhse.png" class="w100 dfgyuxeru" />
    <div class="pd sdfdgdfteeryert">
      <div class="bgff yj4 pd pt20 pr">
        <p class="cen">
          <span class="fz16 z3 pr f_b jjnndsrtywe">{{ title }}</span>
        </p>
        <div class="mt30">
          <van-field
            placeholder="请输入用户名"
            v-model="loginInput.userName"
            :rules="[{ required: true }]"
            clearable
          >
            <template slot="label">
              <i class="f_i jjnnjxer cz"></i>
              <span class="ml10 cz">用户名</span>
            </template>
          </van-field>
          <van-field
            placeholder="请输入密码"
            type="password"
            v-model="loginInput.password"
            :rules="[{ required: true }]"
            clearable
          >
            <template slot="label">
              <i class="f_i jjnnjxer cz ab"></i>
              <span class="ml10 cz">密 码</span>
            </template>
          </van-field>

          <div class="mt30">
            <van-button
              type="primary"
              class="w100"
              :loading="loading"
              @click="onClick"
              >{{ shouldBindMember ? "绑定" : "登录" }}</van-button
            >
            <p class="cen pt10 cen zts" v-if="!shouldBindMember">
              <router-link class="zts pr30" to="/groupregist"
                >团队注册</router-link
              ><a class="zts pl30" @click="onForgetPassword">忘记密码?</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="forgetPassword"
      duration="0"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="cen pm10 mt10 notice-title">找回密码</div>
      <div class="notice-cross">
        <van-icon name="cross" @click="forgetPassword = false" />
      </div>
      <div class="pd pt10 pm10 fz14">
        <van-field
          placeholder="请输入用户名"
          v-model="userName"
          :rules="[{ required: true }]"
          clearable
        >
          <template slot="label">
            <i class="f_i jjnnjxer cz"></i>
            <span class="ml10 cz">用户名</span>
          </template>
        </van-field>
        <van-cell
          class="certNo"
          :value="contactCertNo || '请输入注册时登记的身份证'"
          plain
          type="primary"
          @touchstart.native.stop="onShowNumberKeyboard"
          :value-class="contactCertNo ? 'z4' : ''"
        >
          <template slot="title">
            <i class="f_i jjnnjxer cz ae"></i>
            <span class="custom-title">身份证</span>
          </template>
        </van-cell>
        <div
          class="regist-notice fz12 pd mb10 notice-checkbox"
          style="line-height: 20px; color: red"
        >
          <div class="mt10">
            我们将发送一条修改密码的信息到“{{
              options.CompanyName
            }}”公众号，确认发送成功后请前往公众号查看信息。
          </div>
        </div>
        <div>
          <van-button
            type="primary"
            block
            :loading="loading"
            @click="onSendPassword"
            >确认发送</van-button
          >
        </div>
      </div>

      <van-number-keyboard
        safe-area-inset-bottom
        theme="custom"
        class=""
        :title="contactCertNo ? '身份证：' + contactCertNo : '请输入身份证号码'"
        v-model="contactCertNo"
        :show="showNumberKeyboard"
        :maxlength="18"
        extra-key="X"
        close-button-text="完成"
        @blur="onBlurContactNumberKeyboard()"
      />
    </van-popup>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "./../store/index.js";
import appConsts from "@/store/consts.js";
const { mapActions } = createNamespacedHelpers("memberModule");
import customerService from "@/services/customerService.js";
import tokenService from "@/services/tokenService.js";
import settingService from "@/services/settingService.js";
import validate from "@/utils/validator.js";

export default {
  data() {
    return {
      title: "团队登录",
      loading: false,
      forgetPassword: false,
      multipleUserName: false,
      loginInput: {
        userName: "",
        password: "",
      },
      userName: "",
      contactCertNo: "",
      showNumberKeyboard: false,
      options: {},
    };
  },
  props: {
    shouldBind: {
      type: String,
      default: "0",
    },
    nextPath: {
      type: String,
      default: "",
    },
    ticketTypeIds: {
      type: String,
    },
  },
  computed: {
    shouldBindMember() {
      return this.shouldBind === "1";
    },
  },
  methods: {
    onBlurContactNumberKeyboard() {
      try {
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });
        let result = validate([
          {
            value: this.contactCertNo,
            name: "证件号码",
            rules: certRules,
          },
        ]);

        if (!result.success) {
          this.$toast(result.message);
        }
      } finally {
        this.showNumberKeyboard = false;
      }
    },
    onSendPassword() {
      try {
        this.loading = true;
        let certRules = [
          {
            rule: "required",
          },
        ];
        certRules.push({
          rule: "isIdCard",
        });

        let validateRules = [
          {
            value: this.userName,
            name: "用户名",
            rules: [
              {
                rule: "required",
              },
            ],
          },
          {
            value: this.contactCertNo,
            name: "证件号码",
            rules: certRules,
          },
        ];
        let result = validate(validateRules);
        if (!result.success) {
          this.$toast(result.message);
          this.loading = false;
          return;
        }

        customerService
          .getCustomerByUidAndNameAsync(this.userName, this.contactCertNo)
          .then((customers) => {
            if (customers && customers.length > 0) {
              this.forgetPassword = false;
              customerService
                .sendResetPasswordMessageAsync(customers[0].id)
                .then(() => {
                  this.$toast("发送成功");
                });
            } else {
              this.$toast("用户名或身份证不存在，请重新输入！");
              this.loading = false;
              return;
            }
          });

        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    onShowNumberKeyboard() {
      document.activeElement.blur();
      this.showNumberKeyboard = true;
    },
    onForgetPassword() {
      this.userName = this.contactCertNo = "";
      this.forgetPassword = true;
    },
    async onClick() {
      try {
        this.loading = true;
        await this.login();
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    },
    async login() {
      let validateRules = [
        {
          value: this.loginInput.userName,
          name: "用户名",
          rules: [
            {
              rule: "required",
            },
          ],
        },
        {
          value: this.loginInput.password,
          name: "密码",
          rules: [
            {
              rule: "required",
            },
          ],
        },
      ];
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }

      this.loginInput.shouldBindMember = this.shouldBindMember;
      let token = await customerService.loginFromWeChatAsync(this.loginInput);
      tokenService.setToken(token.access_token);

      await this.refreshMemberAsync();

      if (this.nextPath) {
        //this.$router.replace(`/${this.nextPath}?ticketTypeIds=${this.ticketTypeIds}`);
        this.$router.replace({
          name: this.nextPath,
          params: { ticketTypeIds: this.ticketTypeIds },
        });
      } else {
        this.$router.go(-1);
      }
    },
    ...mapActions([appConsts.refreshMemberAsync]),
  },
  async created() {
    this.title = this.shouldBindMember ? "团队绑定" : "团队登录";
    window.document.title = this.title;
    store.commit(appConsts.setTitle, this.title);

    this.options = await settingService.getOptionsAsync();
  },
};
</script>

<style lang="scss">
</style>